import {
    deleteNewsLetterItemsRepo
  } from "../repositories/newsletter"
import { createSlice } from "@reduxjs/toolkit";

const DeleteNewsLetterItemsSlice = createSlice({
      name:"deleteNewsLetterItemsReducer",
      initialState:{
        newsLetterItemsLoading: false,
        newsLetterItemsData: null,
        newsLetterItemsError: null,
        },
    reducers:{
        deleteNewsLetterItemsLoading(state, action) {
            return {
                ...state,
                newsLetterItemsLoading: true,
            };
        },
        deleteNewsLetterItemsSuccess(state, action) {
            return {
                ...state,
                newsLetterItemsLoading: false,
                newsLetterItemsData: action.payload,
            };
        },
        deleteNewsLetterItemsFailure(state, action) {
            return {
                ...state,
                newsLetterItemsLoading: false,
                newsLetterItemsError: action.payload,
                
            };
        },
        clearNewsLetterItemsReponse(state, action) {//remove
            return {
                ...state,
                newsLetterItemsData: null,
                newsLetterItemsError: null,
            };
        },  
}
})

export const {
    deleteNewsLetterItemsLoading,
    deleteNewsLetterItemsSuccess,
    deleteNewsLetterItemsFailure,
    clearNewsLetterItemsReponse,

} = DeleteNewsLetterItemsSlice.actions;


export const deleteNewsLetterItems = (params) => {
    return async (dispatch) => {
        dispatch(deleteNewsLetterItemsLoading());
        await  deleteNewsLetterItemsRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(deleteNewsLetterItemsSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deleteNewsLetterItemsFailure(error.message));
                }
            });
    };
};
export default DeleteNewsLetterItemsSlice.reducer;